module.exports = __webpack_public_path__ + "static/media/doodle_staking.8dd18074.png";